export const it = {
  toast: {
    error: {
      offlineModuleModelNotSaveable: "Salvataggio offline non permesso",
    },
    success: {},
    warning: {},
  },
};
